import { ButtonsGroup } from '../buttons-group';
import styles from './styles.module.scss';
import { VHCRecordCheckResultDto } from 'api/generated';
import { InlineSvg } from 'components/svg';
import { useAuth } from 'features/auth/contexts/auth';
import { useVhcRecordsRepairOrderQuoteMutation } from 'features/vhc/api/use-vhc-records-repair-order-quote.mutation';
import { FC } from 'react';

export const NotFoundComponent: FC<{
  checkResult: Array<VHCRecordCheckResultDto>;
  recordId?: number;
  refetch: VoidFunction;
  soHeaderId?: number;
  regNo?: string;
  dateCompleted?: string | null;
}> = ({ checkResult, recordId, refetch, soHeaderId, regNo, dateCompleted }) => {
  const { currentUser } = useAuth();

  const { mutate: createQuote, isLoading: isLoadingCreateQuote } = useVhcRecordsRepairOrderQuoteMutation();

  const handleCreateQuote = () => {
    if (!recordId) return;

    createQuote(
      {
        id: recordId,
        userId: currentUser?.userId
      },
      {
        onSuccess: () => {
          refetch();
        }
      }
    );
  };

  return (
    <div>
      <div className={styles.container}>
        <InlineSvg path={'/media/icons/custom/information-4.svg'} />
        <div>Quote not found</div>
      </div>

      <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start mt-10 gap-3">
        <button
          type="button"
          onClick={handleCreateQuote}
          className="btn btn-primary w-100 w-md-auto mb-1"
          disabled={!recordId || !currentUser?.userId || isLoadingCreateQuote}
        >
          Create Quote
        </button>

        <ButtonsGroup soHeaderId={soHeaderId} checkResult={checkResult} dateCompleted={dateCompleted} />
      </div>
    </div>
  );
};
